import React, { useEffect, useState, useMemo } from "react";
import SectionHeader from "../../components/sectionHeader/sectionHeader";
import Card from "../../components/card/card";
import { getApiInstance } from "../../utils/api";
import "./boh.scss";
import InputSearch from "../../components/inputs/inputSearch/inputSearch";
import { useParams, useSearchParams } from "react-router-dom";
import Button from "../../components/button/button";
import { IoReloadOutline } from "react-icons/io5";
import { searchByKeywords } from "../../utils/searchUtils";


export default function Boh() {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchTerm, setSearchTerm] = useState("");
    const { subcategoria } = useParams();
    const [visibleCount, setVisibleCount] = useState(15);
    const [allProducts, setAllProducts] = useState([]);
    const [allGlobal, setAllGlobal] = useState(null);
    const [loadingGlobal, setLoadingGlobal] = useState(false);
    useEffect(() => {
    const term = searchParams.get("q") || "";
    setSearchTerm(term);
}, [searchParams]);

    useEffect(() => {
  const loadAll = async () => {
    if (!searchTerm || allGlobal) return; // ya cargado o no hace falta
    try {
      setLoadingGlobal(true);
      const api = getApiInstance();
      const res = await api.get('/api/Mueble/GetMueblesCatalogo'); // endpoint global
      setAllGlobal(res.data);
    } catch (e) {
      console.error('Error cargando catálogo global', e);
    } finally {
      setLoadingGlobal(false);
    }
  };
  loadAll();
}, [searchTerm, allGlobal]);


    const subcategoriaCodigos = {
        munich: [9],
        copenhague: [10],
        miami: [11],
        oxford: [13],
        "make-up-400": [8],
        todo: [],
    };

    // Mapeo de códigos de categoría a nombres descriptivos
    const categoriasMap = {
        8: "Make Up 400",
        9: "Munich",
        10: "Copenhague", 
        11: "Miami-Splau",
        13: "Oxford"
    };

    useEffect(() => {
        fetchProducts(subcategoria);
    }, [subcategoria]);

    const fetchProducts = async (subcategoriaKey) => {
        setLoading(true);
        const api = getApiInstance();
        const codsCategoria = subcategoriaCodigos[subcategoriaKey] || [];
        const codFamilia = 9; // BOH

        try {
            let productsData = [];

            if (subcategoriaKey === "todo") {
                const response = await api.get(
                    `/api/Mueble/GetMueblesByFamilia/${codFamilia}`
                );
                productsData = response.data;
            } else {
                const endpointBase = `/api/Mueble/GetMueblesByFamiliaCategoria?codFamilia=${codFamilia}&codCategoria=`;
                const promises = codsCategoria.map((cod) =>
                    api
                        .get(`${endpointBase}${cod}`)
                        .catch((err) =>
                            console.error(
                                `Error fetching category ${cod}:`,
                                err
                            )
                        )
                );
                const responses = await Promise.all(promises);
                productsData = responses.flatMap((response) =>
                    response ? response.data : []
                );
            }

            setProducts(productsData);
            setFilteredProducts(productsData);
            setAllProducts(productsData);
            setVisibleCount(15);
            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar los muebles. Vuelve a intentarlo más tarde."
            );
            setProducts([]);
            setFilteredProducts([]);
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

const visibleProducts = useMemo(() => {
    if (!searchTerm) return products;
    const base = allGlobal ?? products;
    return searchByKeywords(base, searchTerm, [
        "referencia",
        "nombreBook",
        "nombreFamilia",
    ]);
}, [searchTerm, products, allGlobal]);

    const handleSearch = (term) => {
        setVisibleCount(15);
    setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev);
        if (term) {
            newParams.set("q", term);
        } else {
            newParams.delete("q");
        }
        return newParams;
    });
};

    if (loading)
        return (
            <div className="muebles-pages__error-message">
                Cargando muebles...
            </div>
        );
    if (error)
        return (
            <div className="muebles-pages__error-message">Error: {error}</div>
        );

    return (
        <div className="boh">
            <SectionHeader title={`BOH - ${subcategoria}`} />
            <div className="boh__header">
                <div className="boh__header__search">
                    <InputSearch
                        context="tableSearch"
                        value={searchTerm}
                        onSearch={handleSearch}
                        placeholder="Buscar productos..."
                    />
                </div>
            </div>

            <div className="boh__cards">
                {visibleProducts.length > 0 ? (
                    <>
                        {visibleProducts
                            .slice(0, visibleCount)
                            .map((product) => (
                                <Card
                                    key={product.codMueble}
                                    title={product.nombreBook}
                                    subtitle={product.nombreFamilia}
                                    reference={product.referencia}
                                codCategoria={
                                        // Primera opción: si tiene codCategorias (números), mapear a nombres
                                        product.codCategorias && product.codCategorias.length > 0 
                                            ? product.codCategorias.map(codigo => categoriasMap[codigo] || codigo).join(", ")
                                            // Segunda opción: si tiene categorias (strings), usar directamente
                                            : product.categorias && product.categorias.length > 0
                                                ? product.categorias.join(", ")
                                                : null
                                    }
                                    image={product.rutaImagen}
                                    link={`/ficha-producto/${product.codMueble}`}
                                    pendienteAprobacion={
                                        product.pendienteDeAprobacion
                                    }
                                    showButton={true}
                                    // badgeLabel="24"
                                    // badgeVariant="info"
                                    // tooltipContent="Este mueble es de edición limitadaasdasd asdasdasdasdasdasdas"
                                />
                            ))}

                        {visibleCount < visibleProducts.length && (
                            <div className="mobiliario-central__load-more-container">
                                <Button
                                    label="Cargar más"
                                    variant="filled"
                                    icon={<IoReloadOutline />}
                                    onClick={() =>
                                        setVisibleCount((prev) => prev + 15)
                                    }
                                />
                            </div>
                        )}
                    </>
                ) : (
                    <p className="boh__cards__no-results-message">
                        No hay muebles en esta categoría
                    </p>
                )}
            </div>
        </div>
    );
}
